import { t } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { getGroupsByIds } from 'APP/model/group/groupModel';
import Entities from 'STORE';

async function loadGroup(id, isChannel) {
  try {
    const response = await getGroupsByIds([id]);
    if ((response?.userBannedInGroups || []).includes(id)) {
      Tasks.app.showAlert(t('banned_user_deeplink_error'));

      return;
    }
    if (response?.items?.[0]) {
      Entities.GroupsStore.merge([response.items[0]]);
      await Tasks.relationships.loadUnknownDataFromGroups({
        groups: [Entities.GroupsStore.getGroupById(id)],
      });
      return Entities.GroupsStore.getGroupById(id);
    }

    Tasks.app.showAlert(
      isChannel ? t('common_channel_is_not_accessible') : t('common_chat_is_not_accessible')
    );
  } catch (error) {
    return;
  }
}

export async function handleGroup({ groupId, isChannel = false }) {
  if (!groupId) {
    return null;
  }
  let group = Entities.GroupsStore.getGroupById(groupId);

  if (!group) {
    group = await loadGroup(groupId, isChannel);

    const isJoinGroupRequired = !!group && group.isChatGroup && group.isClosed && !group.isMember;

    if (isJoinGroupRequired) {
      await Tasks.group.joinGroup({ groupId });
      group = Entities.GroupsStore.getGroupById(groupId);
    }
  }

  if (!group) {
    return null;
  }

  return {
    groupRoute: `/${group.route}/${group.id}`,
    spaceId: group.spaceId,
  };
}
